// Step 1: App.jsx - This is your main component that controls what to render
import { useState } from 'react'
import './App.css'
import LoginComponent from './LoginComponent.jsx'
import VDartSatisfactionDashboard from './VDartSatisfactionDashboard.jsx'

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [userEmail, setUserEmail] = useState('')

  const handleLogin = (email) => {
    setUserEmail(email)
    setIsLoggedIn(true)
  }

  // This is where the magic happens - conditional rendering
  return (
    <>
      {!isLoggedIn ? (
        // Show login screen when NOT logged in
        <LoginComponent onLogin={handleLogin} />
      ) : (
        // Show dashboard when logged in
        <VDartSatisfactionDashboard userEmail={userEmail} />
      )}
    </>
  )
}

export default App